import React, {useEffect, useRef, useState} from "react";
import { compose } from "redux";
import enhancer from "./validator";
import Select from 'react-select';

const UserForm = props => {

    const selectRole = useRef('');
    const [loading, setLoading] = useState(false);

    const {
        handleChange,
        handleBlur,
        errors,
        touched,
        submitCount,
        setFieldValue,
        onSubmit,
        values,
        action,
    } = props;

    const Error = props => {
        const field1 = props.field;
        if ((errors[field1] && touched[field1]) || submitCount > 0) {
            return (
                <span className={props.class ? props.class : "error-msg"}>
                    {errors[field1]}
                </span>
            );
        } else {
            return <span></span>;
        }
    };

    useEffect(() => {
        if(values.role && !loading){
            if( values.role === "Admin"){
                selectRole.current.select.setValue({value: 10, label: "Admin"})
            } else if (values.role === "Servis Üyesi") {
                selectRole.current.select.setValue({value: 15, label: "Servis Üyesi"})
            }
            setLoading(true);
        }
    },[values.role])

    const handleSubmit = () => {
        let { values, isValid, handleSubmit } = props;
        if (isValid) {
            onSubmit(values, action);
        }
        handleSubmit();
    };
    return (
        <div>
            <form>
                <div className="form-group">
                    <label className="fs-16 medium-text">First Name</label>
                    <input
                        type="text"
                        className="form-control react-form-input"
                        id="firstname"
                        onChange={handleChange}
                        onBlur={handleBlur}
                        value={values.firstname}
                        placeholder="İsim"
                    />
                    <Error field="firstname" />
                </div>

                <div className="form-group">
                    <label className="fs-16 medium-text">Last Name</label>
                    <input
                        type="text"
                        className="form-control react-form-input"
                        id="lastname"
                        onChange={handleChange}
                        onBlur={handleBlur}
                        value={values.lastname}
                        placeholder="Soyisim"
                    />
                    <Error field="lastname" />
                </div>

                <div className="form-group">
                    <label className="fs-16 medium-text">Email</label>
                    <input
                        type="email"
                        className="form-control react-form-input"
                        id="email"
                        onChange={handleChange}
                        onBlur={handleBlur}
                        value={values.email}
                        placeholder="Email"
                    />
                    <Error field="email" />
                </div>
                {   
                    action === 'add' &&
                    <div className="form-group">
                        <label className="fs-16 medium-text">Şifre</label>
                        <input
                            type="password"
                            className="form-control react-form-input"
                            id="password"
                            onChange={handleChange}
                            onBlur={handleBlur}
                            value={values.password}
                            placeholder="Şifre"
                        />
                        <Error field="password" />
                    </div>
                }

                {   
                    action === 'edit' &&
                    <div className="form-group">
                        <label className="fs-16 medium-text">Şifre</label>
                        <input
                            type="password"
                            className="form-control react-form-input"
                            id="password"
                            onBlur={handleBlur}
                            value="protected"
                            placeholder="Şifre"
                            readOnly
                        />
                        <Error field="password" />
                    </div>
                }


                <div className="form-group">
                    <label className="fs-16 medium-text">Phone Number</label>
                    <input
                        type="text"
                        className="form-control react-form-input"
                        id="phone_number"
                        onChange={handleChange}
                        onBlur={handleBlur}
                        value={values.phone_number}
                        placeholder="Phone Number"
                    />
                    <Error field="phone_number" />
                </div>
                
                <div className="form-group">
                    <label className="fs-16 medium-text">Pozisyon</label>
                    <Select
                        ref={selectRole}
                        placeholder="select options"
                        onChange={value => setFieldValue('role', value)}
                        id="role"
                        name="role"
                        options={[
                            { value: 10, label: "Admin" },
                            { value: 15, label: "Servis Üyesi"}
                          ]}
                    />
                    <Error field="role" />
                </div>



                <div>
                    <button
                        type="button"
                        className="c-btn c-info form-button fs-16 demi-bold-text"
                        style={{ maxWidth: "125px" }}
                        onClick={() => handleSubmit()}
                    >
                        Submit
                    </button>
                </div>
            </form>
        </div>
    );
};

export default compose(enhancer)(UserForm);
